/**
 * Maps settings keywords for a given dropdown name into { value, label } options.
 *
 * @param {Array} keywords - Array of keyword objects from settings
 * @param {string} dropdownName - The dropdownName to filter by
 * @param {Function} [labelFormatter] - Optional function to format the label from an option.
 *   Receives the raw option (string or object). If omitted, uses o.label for objects and o for strings.
 * @returns {Array<{value: string, label: string}>} Mapped options
 */
const getOptionValue = (o) => (typeof o === 'string' ? o : o.value);

const getOptionLabel = (o) => (typeof o === 'string' ? o : o.label);

export const mapSettingsKeywords = (keywords, dropdownName, labelFormatter) => {
  return keywords
    .filter((k) => k.dropdownName === dropdownName)
    .flatMap((k) =>
      (k.options || []).map((o) => ({
        value: getOptionValue(o),
        label: labelFormatter ? labelFormatter(o) : getOptionLabel(o),
      }))
    );
};
